"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenText = void 0;
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var SkeletonElement_1 = __importDefault(require("@atg/icf-react-components/components/SkeletonElement"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var getSkeletonLength = function (text, dynamicUpperRangeThreshold, dynamicWidthRange) {
    var _a = dynamicWidthRange.lowerRange, lowerRange = _a === void 0 ? 70 : _a, _b = dynamicWidthRange.upperRange, upperRange = _b === void 0 ? 100 : _b;
    if (typeof text !== "string")
        return "".concat(upperRange, "%");
    if (text.length >= dynamicUpperRangeThreshold) {
        return "".concat(upperRange, "%");
    }
    var width = lowerRange + (text.length / dynamicUpperRangeThreshold) * (upperRange - lowerRange);
    return "".concat(width, "%");
};
/**
 * Shows a skeleton placeholder element to hide text content
 *
 * @constructor
 *
 * @param {IProps} props - The component props
 * @param {ReactNode} props.text - The text to hide
 * @param {string} [props.className] - The class name to apply to the element
 * @param {boolean} [props.useAnimation] - Whether to use the skeleton pulse animation
 * @param {number} [props.opacity] - The opacity of the skeleton element
 * @param {string} [props.width] - Fixed width of the component
 * @param {number} [props.dynamicUpperRangeThreshold] - The text length at which width reaches 100%
 * @param {{ lowerRange: number, upperRange: number }} [props.dynamicWidthRange] -
 * An object containing the lower and upper bounds for the dynamic width calculation in percentage.
 */
var HiddenText = function (_a) {
    var _b;
    var text = _a.text, className = _a.className, _c = _a.useAnimation, useAnimation = _c === void 0 ? false : _c, opacity = _a.opacity, width = _a.width, _d = _a.dynamicUpperRangeThreshold, dynamicUpperRangeThreshold = _d === void 0 ? 10 : _d, _e = _a.dynamicWidthRange, dynamicWidthRange = _e === void 0 ? { lowerRange: 70, upperRange: 100 } : _e;
    var classes = getStyles();
    var skeletonWidth = width !== null && width !== void 0 ? width : getSkeletonLength(text, dynamicUpperRangeThreshold, dynamicWidthRange);
    return (react_1.default.createElement(SkeletonElement_1.default, { width: skeletonWidth, className: (0, classnames_1.default)(className, (_b = {},
            _b[classes.noAnimation] = !useAnimation,
            _b)), style: { opacity: opacity } }));
};
exports.HiddenText = HiddenText;
var getStyles = (0, react_jss_1.createUseStyles)(function () { return ({
    noAnimation: {
        animation: "unset",
    },
}); });
exports.HiddenText.displayName = "HiddenText";
//# sourceMappingURL=HiddenText.js.map